import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name:'', phone:'', email:'', age:'', condition:'', doctor:'', timeSlot:'', message:'', source:'' });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const set = k => e => { setForm(f=>({...f,[k]:e.target.value})); if(errors[k]) setErrors(er=>({...er,[k]:''})); };

  const validate = () => {
    const e = {};
    if(!form.name.trim()) e.name='Name is required';
    if(!form.phone.trim()) e.phone='Phone is required';
    else if(!/^\d{10}$/.test(form.phone.replace(/\D/g,''))) e.phone='Enter a valid 10-digit number';
    if(form.email && !/\S+@\S+\.\S+/.test(form.email)) e.email='Enter a valid email';
    if(!form.condition) e.condition='Please select a condition';
    return e;
  };

  const submit = e => {
    e.preventDefault();
    const errs = validate();
    if(Object.keys(errs).length){ setErrors(errs); return; }
    setLoading(true);
    setTimeout(()=>{ setLoading(false); setSubmitted(true); }, 1800);
  };

  const ic = k => `form-input${errors[k]?' input-error':''}`;

  return (
    <div>
      <section className="page-hero" style={{paddingBottom:100}}>
        <div className="container">
          <div className="breadcrumb"><Link to="/">Home</Link><span className="sep">›</span><span>Contact Us</span></div>
          <h1>Book an Appointment</h1>
          <p>Take the first step towards pain-free living. Fill in the form and our team will reach out within 24 hours.</p>
        </div>
      </section>

      <section className="section contact-section">
        <div className="container contact-grid">

          {/* INFO PANEL */}
          <div className="cip">
            <h3 className="cip-title">Get in Touch</h3>
            <div className="cip-item"><div className="cip-icon">📍</div><div><div className="cip-lbl">Location</div><div className="cip-val">Hyderabad, Telangana, India</div><div className="cip-sub">Get Directions →</div></div></div>
            <div className="cip-item"><div className="cip-icon">📞</div><div><div className="cip-lbl">Phone</div><div className="cip-val">+91 XXXXX XXXXX</div><div className="cip-sub">Call Now</div></div></div>
            <div className="cip-item"><div className="cip-icon">✉️</div><div><div className="cip-lbl">Email</div><div className="cip-val">info@theorthomed.com</div><div className="cip-sub">Write to us</div></div></div>
            <div className="cip-item"><div className="cip-icon">🕐</div><div><div className="cip-lbl">Working Hours</div><div className="cip-val">Mon – Sat: 9 AM – 7 PM</div><div className="cip-sub">Sunday: By Appointment</div></div></div>
            <div className="cip-docs">
              <div className="cip-doc-title">Our Specialists</div>
              <div className="cip-doc"><div className="cip-av" style={{background:'#0D4E9A'}}>GB</div><div><div className="cip-dn">Dr. Geetha Bhargavi</div><div className="cip-dr">Pain Medicine & Spine</div></div></div>
              <div className="cip-doc"><div className="cip-av" style={{background:'#1565C0'}}>SP</div><div><div className="cip-dn">Dr. Sadhan Palakuri</div><div className="cip-dr">Sports Orthopaedics</div></div></div>
            </div>
            <div className="cip-emergency"><span style={{fontSize:20}}>🚨</span><div><div style={{fontSize:13,fontWeight:700,color:'#fff',marginBottom:2}}>Sports Emergency?</div><div style={{fontSize:12,color:'rgba(255,255,255,0.72)'}}>Same-day appointments available for acute injuries</div></div></div>
          </div>

          {/* FORM */}
          <div className="cfp">
            {submitted ? (
              <div className="form-success">
                <div style={{fontSize:56,marginBottom:20}}>✅</div>
                <h3>Appointment Request Sent!</h3>
                <p>Thank you, <strong>{form.name}</strong>. Our team will call you at <strong>{form.phone}</strong> within 24 hours to confirm your appointment.</p>
                <div className="success-details">
                  {form.condition && <div className="sd"><span>Condition:</span>{form.condition}</div>}
                  {form.doctor    && <div className="sd"><span>Doctor:</span>{form.doctor}</div>}
                  {form.timeSlot  && <div className="sd"><span>Preferred Time:</span>{form.timeSlot}</div>}
                </div>
                <button className="form-btn" onClick={()=>{setForm({name:'',phone:'',email:'',age:'',condition:'',doctor:'',timeSlot:'',message:'',source:''});setSubmitted(false);}}>Make Another Enquiry</button>
              </div>
            ) : (
              <form onSubmit={submit} noValidate>
                <div className="cfp-header"><h3>Request an Appointment</h3><p>Fill in your details and we'll get back to you promptly.</p></div>
                <div className="form-row">
                  <div className="form-group"><label>Full Name <span className="req">*</span></label><input className={ic('name')} placeholder="e.g. Ramesh Kumar" value={form.name} onChange={set('name')}/>{errors.name&&<span className="err">{errors.name}</span>}</div>
                  <div className="form-group"><label>Phone Number <span className="req">*</span></label><input className={ic('phone')} type="tel" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={set('phone')}/>{errors.phone&&<span className="err">{errors.phone}</span>}</div>
                </div>
                <div className="form-row">
                  <div className="form-group"><label>Email Address</label><input className={ic('email')} type="email" placeholder="your@email.com" value={form.email} onChange={set('email')}/>{errors.email&&<span className="err">{errors.email}</span>}</div>
                  <div className="form-group"><label>Age</label><input className="form-input" type="number" placeholder="Your age" min="1" max="120" value={form.age} onChange={set('age')}/></div>
                </div>
                <div className="form-group">
                  <label>Condition / Treatment Needed <span className="req">*</span></label>
                  <select className={ic('condition')} value={form.condition} onChange={set('condition')}>
                    <option value="">— Select your condition or treatment —</option>
                    <optgroup label="Pain Medicine">
                      <option>Chronic Joint Pain</option><option>Back / Neck Pain</option><option>PRP Therapy</option><option>Stem Cell Therapy</option><option>BMAC Therapy</option><option>Spine Intervention</option><option>Nerve Pain</option><option>Arthritis</option><option>Tendinitis / RSI</option>
                    </optgroup>
                    <optgroup label="Sports Orthopaedics">
                      <option>ACL / PCL Tear</option><option>Meniscus Injury</option><option>Rotator Cuff Tear</option><option>Arthroscopy</option><option>Knee Replacement</option><option>Sports Injury</option><option>Shoulder Instability</option>
                    </optgroup>
                    <optgroup label="Physiotherapy">
                      <option>Sports Physiotherapy</option><option>Post-Surgical Rehab</option><option>Strength Training</option><option>Sports Rehabilitation</option>
                    </optgroup>
                    <option>General Consultation</option><option>Other</option>
                  </select>
                  {errors.condition&&<span className="err">{errors.condition}</span>}
                </div>
                <div className="form-group">
                  <label>Preferred Doctor</label>
                  <select className="form-input" value={form.doctor} onChange={set('doctor')}>
                    <option value="">— No preference / first available —</option>
                    <option>Dr. Geetha Bhargavi (Pain Medicine & Spine)</option>
                    <option>Dr. Sadhan Palakuri (Sports Orthopaedics)</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Preferred Appointment Slot</label>
                  <div className="time-slots">
                    {['Morning (9–12 PM)','Afternoon (12–3 PM)','Evening (3–7 PM)','Weekends Only'].map(s=>(
                      <button key={s} type="button" className={`tslot${form.timeSlot===s?' selected':''}`} onClick={()=>setForm(f=>({...f,timeSlot:f.timeSlot===s?'':s}))}>{s}</button>
                    ))}
                  </div>
                </div>
                <div className="form-group"><label>Describe Your Condition <span style={{color:'#94A3B8',fontWeight:400}}>(optional)</span></label><textarea className="form-input" rows={4} placeholder="Brief description of your symptoms, how long you've had them, previous treatments tried..." value={form.message} onChange={set('message')} style={{resize:'vertical'}}/></div>
                <div className="form-group">
                  <label>How Did You Hear About Us?</label>
                  <select className="form-input" value={form.source} onChange={set('source')}>
                    <option value="">— Select —</option><option>Google Search</option><option>Social Media</option><option>Doctor Referral</option><option>Friend / Family</option><option>Other</option>
                  </select>
                </div>
                <button type="submit" className="form-btn" disabled={loading}>{loading?'Submitting...':'Request Appointment →'}</button>
                <p className="form-privacy">🔒 Your information is completely confidential and will only be used to contact you about your appointment.</p>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* MAP */}
      <section style={{background:'#F8FAFC',padding:'0 0 72px'}}>
        <div className="container">
          <div style={{borderRadius:20,overflow:'hidden',border:'1.5px solid #D9E4F0',height:300,background:'#E8F1FB',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:12}}>
            <div style={{fontSize:40}}>📍</div>
            <div style={{fontSize:18,fontWeight:700,color:'#0D4E9A'}}>TheOrthomed, Hyderabad</div>
            <div style={{fontSize:14,color:'#475569'}}>Telangana, India</div>
            <a href="https://maps.google.com/?q=Hyderabad+Telangana" target="_blank" rel="noreferrer" style={{marginTop:8,display:'inline-flex',padding:'10px 22px',background:'#0D4E9A',color:'#fff',borderRadius:8,fontWeight:700,fontSize:14,textDecoration:'none'}}>Open in Google Maps →</a>
          </div>
        </div>
      </section>
    </div>
  );
}
